import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { AuthType, clearLoginStorage, GetCurrentAuthType } from "@shared/utils/AuthUtils";
import { redirectTo, selectIsInTeams, setAuthLoading } from "@shared/store/auth.duck";
import { Column } from '@shared/ui/atoms/StructuralLayout';
import { CurrentUserAvatarAndName } from '@shared/ui/molecules/UserAvatarAndName';
import { Link } from "react-router-dom";
import { HeadlineXtraSmall } from '@shared/ui/atoms/fonts/Headline';
import { useTranslation } from "react-i18next";
import { useMsal } from "@azure/msal-react";

export function MicrosoftTeamsLogoutButton(props: Props) {
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const {instance} = useMsal();
  const isInTeams = useSelector(selectIsInTeams);

  const logout = async () => {
    clearLoginStorage();
    dispatch(setAuthLoading(true));
    props.onClick();
    try {
      await instance.logoutRedirect({postLogoutRedirectUri: `${window.location.origin}/login`,});
      dispatch(redirectTo('/logout/azure'))
    } finally {
      setAuthLoading(false);
    }
  };

  if (isInTeams && GetCurrentAuthType() === AuthType.Microsoft) {
    return null;
  }

  return (
    <Column className="logoutMenuItem">
      <CurrentUserAvatarAndName className="logoutMenuItem__avatar" colour="blue" hideName={true}/>
      <Link to="#" onClick={logout} className="logoutMenuItem__link noSelect">
        <HeadlineXtraSmall className="logoutMenuItem__text">{t('button.logout')} </HeadlineXtraSmall>
        <img src="/assets/icons/font/Logout.svg" alt="" />
      </Link>
    </Column>
  )
}

interface Props {
  onClick: () => any;
}
